import '@babel/polyfill';
import 'whatwg-fetch';
import React from 'react';
import ReactDOM from 'react-dom';
import jsbridge from '@xpeng/js-bridge'
import 'normalize.css';
import './index.css';
import App from './app';
import InitRun from '../../common/initial';
import { initGdp } from '../../utils/gio-report'
import { getClientEnv } from '../../utils/common'

// 福利页重定向到专题页（在React渲染之前执行，避免闪屏）
// 仅匹配 marketing.html#/?pageId=charge_welfare
(function() {
  try {
    const hash = window.location.hash.slice(1) || '/'
    const [pathname, search] = hash.split('?')
    const params = new URLSearchParams(search)
    const pageId = params.get('pageId')
    
    if (pathname === '/' && pageId === 'charge_welfare') {
      const { origin } = window.location
      const env = getClientEnv()
      const pageCode = env === 'deploy' ? 'PAGE26591956' : 'PAGE68226399'
      // 将原始参数（除 pageId 外）平移到目标 URL
      params.delete('pageId')
      const extraParams = params.toString()
      const targetUrl = `${origin}/apps/charge-web/par-marketing.html#configPage?pageCode=${pageCode}${extraParams ? '&' + extraParams : ''}`
      window.location.replace(targetUrl)
      return // 阻止后续代码执行
    }
  } catch (error) {
    console.error('重定向逻辑执行失败:', error)
    // 继续正常渲染
  }

  // 正常初始化流程
  initGdp();
  InitRun();

  const callHandlerOrigin = jsbridge.callHandler;
  jsbridge.callHandler = (method, params) => {
    console.log(`====== bridge callHandler start =====`)
    console.log(`method: ${method}`);
    console.log('params: ');
    console.log(params);
    return callHandlerOrigin.call(jsbridge, method, params).then(res => {
      console.log(`method: ${method}`);
      console.log('response: ');
      console.log(res);
      console.log(`====== bridge callHandler end ======`)
      return res;
    }).catch(err => {
      console.log(`method: ${method}`);
      console.log('error: ');
      console.log(err);
      console.log(`====== bridge callHandler end ======`)
      throw err;
    });
  }

  ReactDOM.render(<App />, document.getElementById('root'));
})();
